/**
 * Project : workspace
 * File    : ShareQRLinkCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.home.component

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import component.image.AsyncImageView
import org.jetbrains.compose.ui.tooling.preview.Preview
import theme.ThemeColor

/**
 * Represents the share q r link card class.
 */

class ShareQRLinkCard {
    private val textBoxTextStyle = Modifier.wrapContentHeight()
        .wrapContentWidth()
        .padding(start = 16.dp, end = 16.dp, top = 0.dp, bottom = 0.dp)

    val image = "https://firebasestorage.googleapis.com/v0/b/friendly-26dc3.firebasestorage.app/o/menu%2Fbusiness_home%2Fscanner.png?alt=media&token=2a69a52a-5224-40fa-86fe-25939a6b6a56"
    @Preview
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @param onClick The on click.
 * @return Unit – no return value.
 */
    fun content(onClick:()->Unit){
        Card(
            modifier = Modifier
                .wrapContentHeight()
                .fillMaxWidth()
                .background(color = ThemeColor.shared().PrimaryColor, RoundedCornerShape(10.dp))
                .padding(bottom = 8.dp)
                .clickable {
                    onClick()
                },
            colors = CardDefaults.cardColors(
                containerColor = ThemeColor.shared().PrimaryColor,
            ),
            elevation = CardDefaults.cardElevation(
                defaultElevation = 4.dp
            ),
        ) {
            Row(
                modifier = Modifier
                    .padding(horizontal = 16.dp, vertical = 8.dp)
                    .fillMaxWidth()
                    .fillMaxHeight()
                    .background(color = ThemeColor.shared().PrimaryColor),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                Text(
                    text = "Get order just by sharing QR/Link",
                    fontSize = 16.sp,
                    color = ThemeColor.shared().White,
                    textAlign = TextAlign.Center,
                    fontStyle = FontStyle.Normal,fontWeight = FontWeight.SemiBold
                )
                Box (modifier = Modifier.height(30.dp).width(30.dp)){
                    AsyncImageView(image)
                }
            }
        }
    }
}